import Typography from "@/elements/Typography";
import Box from "@/elements/Box";
import Card from "@mui/material/Card";
import { NodoDto, OlioDto } from "@/api";
import Button from "@/elements/Button";
import OilDropIcon from "@/assets/oil-drop-icon.png";
import numeral from "numeral";
import moment from "moment/moment";
import StoricoOlioDialog from "./StoricoOlioDialog";
import { useState } from "react";
import { useAuth } from "@/context/useAuth";
import { useTranslation } from "react-i18next";

export default function CentraleOlioAttualeCard({
  olio,
  nodo,
}: {
  olio: OlioDto | null;
  nodo: NodoDto;
}) {
  const { t } = useTranslation();

  const { hasPermission } = useAuth();
  const [storicoOlioDialogOpen, setStoricoOlioDialogOpen] = useState(false);

  return (
    <Card
      sx={{
        minWidth: {
          xs: "100%",
        },
        maxWidth: 500,
        height: '100%',
        overflow: "unset",
      }}
    >
      <Box p={2} flex={1}>
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" gap={1}>
            <img
              src={OilDropIcon}
              width={100}
              alt={t("centraleOlioAttualeCard.immagineAlt")}
            />

            <Box display="flex" flexDirection="column" gap={1}>
              <Typography
                variant="h5"
                color="text"
                fontWeight="medium"
                gutterBottom
              >
                {t("centraleOlioAttualeCard.titolo")}
              </Typography>

              {olio ? (
                <Typography variant="body2">
                  {t("centraleOlioAttualeCard.campi.modello")}{" "}
                  <strong>
                    {olio.modelloOlio?.marca} - {olio.modelloOlio?.nome}
                  </strong>
                  <br />
                  {t("centraleOlioAttualeCard.campi.quantita")}{" "}
                  <strong>
                    {numeral(olio.quantitaLitri).format("0.0")} {t("unita.litriAbbr")}
                  </strong>
                  <br />
                  {t("centraleOlioAttualeCard.campi.sostituitoIl")}{" "}
                  <strong>
                    {moment(olio.inseritoIl).format("DD/MM/YYYY")}
                  </strong>
                  <br />
                  {t("centraleOlioAttualeCard.campi.ultimaBonifica")}{" "}
                  {nodo.ultimaBonifica && (
                    <strong>
                      {moment(nodo.ultimaBonifica.data).format(
                        "DD/MM/YYYY"
                      )}
                    </strong>
                  )}
                  <br />
                </Typography>
              ) : (
                <Typography variant="body2">
                  <em>{t("centraleOlioAttualeCard.nessunOlio")}</em>
                </Typography>
              )}
            </Box>
          </Box>

          <Box display="flex" flexDirection="row-reverse" width="100%">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={() => {
                setStoricoOlioDialogOpen(true);
              }}
            >
              {t("centraleOlioAttualeCard.azioni.storico")}
            </Button>
          </Box>
        </Box>
      </Box>

      <StoricoOlioDialog
        open={storicoOlioDialogOpen}
        nodo={nodo}
        storicoOlio={nodo.storicoOlio ?? []}
        onClose={() => {
          setStoricoOlioDialogOpen(false);
        }}
        canEdit={hasPermission("ContenitoreUpdateStoricoOlio")}
      />
    </Card>
  );
}
